import { ILoaiBangTotNghiepActionTypes } from "../../action-types/category/ILoaiBangTotNghiepActions";
import { ILoaiBangTotNghiepReduce } from "../../reducer-model/category/ILoaiBangTotNghiepReduce";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";


const iniState: ILoaiBangTotNghiepReduce = {
    status: eReducerStatusBase.is_not_initialization,
    loaiBangTotNghieps: [],
}

export const loaiBangTotNghiepReducer = (state: ILoaiBangTotNghiepReduce = iniState, action: ILoaiBangTotNghiepActionTypes): ILoaiBangTotNghiepReduce => {
    switch (action.type) {
        case "LOAI_BANG_TOT_NGHIEP_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "LOAI_BANG_TOT_NGHIEP_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                loaiBangTotNghieps: action.payload,
            };
        case "LOAI_BANG_TOT_NGHIEP_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "LOAI_BANG_TOT_NGHIEP_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                loaiBangTotNghiepEditing: action.payload,
            };
        case "LOAI_BANG_TOT_NGHIEP_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "LOAI_BANG_TOT_NGHIEP_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "LOAI_BANG_TOT_NGHIEP_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "LOAI_BANG_TOT_NGHIEP_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "LOAI_BANG_TOT_NGHIEP_SHOW_GAN_LOP_MODAL":
            return {
                ...state,
                isShowGanLopModal: true,
                loaiBangTotNghiepGanLop: action.payload,
            };
        case "LOAI_BANG_TOT_NGHIEP_CLOSE_GAN_LOP_MODAL":
            return {
                ...state,
                isShowGanLopModal: false,
            };
        case "LOAI_BANG_TOT_NGHIEP_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "LOAI_BANG_TOT_NGHIEP_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "LOAI_BANG_TOT_NGHIEP_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}
